import { useState } from 'react';

export interface DateRange {
  from: string;
  to: string;
}

/** Today in Vietnam, the day boundary the API groups events by. */
export function todayVn(): string {
  return new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Ho_Chi_Minh' });
}

function daysBack(day: string, n: number): string {
  const d = new Date(`${day}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() - n);
  return d.toISOString().slice(0, 10);
}

const PRESETS = [
  { value: '1', label: 'Today' },
  { value: '7', label: 'Last 7 Days' },
  { value: '30', label: 'Last 30 Days' },
  { value: '90', label: 'Last 90 Days' },
  { value: 'custom', label: 'Custom' },
] as const;

export function lastDays(n: number): DateRange {
  const to = todayVn();
  return { from: daysBack(to, n - 1), to };
}

export const query = (r: DateRange) => `from=${r.from}&to=${r.to}`;
export const percent = (x: number) => `${(x * 100).toFixed(1)}%`;

/** Today / last N days / a custom from–to, as Vietnam dates. */
export function RangePicker({ value, onChange }: { value: DateRange; onChange: (r: DateRange) => void }) {
  const [preset, setPreset] = useState<string>('30');
  return (
    <span className="range-picker">
      <select
        className="filter-select"
        value={preset}
        aria-label="Date range"
        onChange={(e) => {
          setPreset(e.target.value);
          if (e.target.value !== 'custom') onChange(lastDays(Number(e.target.value)));
        }}
      >
        {PRESETS.map((p) => (
          <option key={p.value} value={p.value}>{p.label}</option>
        ))}
      </select>
      {preset === 'custom' ? (
        <>
          <input
            type="date"
            className="filter-select"
            aria-label="From"
            value={value.from}
            max={value.to}
            onChange={(e) => e.target.value && onChange({ ...value, from: e.target.value })}
          />
          <input
            type="date"
            className="filter-select"
            aria-label="To"
            value={value.to}
            min={value.from}
            max={todayVn()}
            onChange={(e) => e.target.value && onChange({ ...value, to: e.target.value })}
          />
        </>
      ) : null}
    </span>
  );
}
